import React, { useEffect } from "react"
import "./index.css"
import { Link } from "gatsby"
import ImageFixed from '../components/imageFixed';
import Layout from "../components/layout"
import SEO from "../components/seo"
import videoBackground from '../images/videosolhd.mp4';
import { useTranslation } from 'react-i18next';


const IndexPage = () => {
  const { t, i18n } = useTranslation();
  
  useEffect(() => {
    const video = document.getElementById('video');
    video.playbackRate = 0.5;

    const energy = document.getElementById('energy-properties');
    energy.style.transition = "transform 1s";

 
        const span = document.getElementById('energy-property-js');
        const spanHeight = span.offsetHeight;
        console.log(spanHeight);


        let position = 0;
        let palabras = 0;
        const timer = setInterval(() => {
          energy.style.transform = `translateY(-${position}px)`;
          position += spanHeight;
          ++palabras;
          if (palabras === 7) {
            clearInterval(timer);
          }
        }, 2000);

  }, []);


  const currentLang = i18n.language;
  let flexColumnChanger = "";
  if (currentLang === 'en') {
    flexColumnChanger = "video-text__left--reverse"
  }
  
  return(
    <Layout>

      <SEO title={t('INDEX_SEO-TITLE')} description={t('INDEX_SEO-DESCRIPTION')}/>
      <div className="video__container">
        <video  autoPlay muted loop id="video" className="video__video">
          <source src={videoBackground} type="video/mp4" loop disablePictureInPicture/>
          Your browser does not support the video tag.
        </video>
        <div className="video__img">
          <ImageFixed queryName="indexWorldBackground" alt="La tierra y el sol" />
        </div>
        <div className="video-text__container">
          <div className={`video-text__left ${flexColumnChanger}`}>
            <span>{t('INDEX_ENERGIA-1')}</span>
            <div className="energy-properties__container">
              <div id="energy-properties">
                <span className="energy-property" id="energy-property-js">{t('INDEX_ENERGIA-2')}</span>
                <span className="energy-property">{t('INDEX_ENERGIA-3')}</span>
                <span className="energy-property">{t('INDEX_ENERGIA-4')}</span>
                <span className="energy-property">{t('INDEX_ENERGIA-5')}</span>
                <span className="energy-property">{t('INDEX_ENERGIA-6')}</span>
                <span className="energy-property">{t('INDEX_ENERGIA-7')}</span>
                <span className="energy-property">{t('INDEX_ENERGIA-8')}</span>
              </div>
            </div>
          </div>
          <div className="video-text__right">
            <h1 className="video-text__h1">{t('INDEX_TITULO-H1')}</h1>
            <p>{t('INDEX_TITULO-P')}</p>
          </div>
        </div>
      </div>
      <div className="main__container">
        <h3 className="home__h3">{t('INDEX_H3')}</h3>
        <div className="cards__container">
          <Link to="/parks">
              <div className="card">
                  <div className="card__img">
                    <ImageFixed queryName="indexParques" alt="Parques solares" />
                  </div>
                  <p className="card__title">{t('INDEX_CARD-1_TITLE')}</p>
                  <p className="card__resume">{t('INDEX_CARD-1_RESUME')}</p>
              </div>
          </Link>
          <Link to="/investigation">
            <div className="card">
                <div className="card__img">
                    <ImageFixed queryName="indexInvestigacion" alt="Investigación y desarrollo" />
                </div>
                <p className="card__title">{t('INDEX_CARD-2_TITLE')}</p>
                <p className="card__resume">{t('INDEX_CARD-2_RESUME')}</p>
            </div>
          </Link>
          <Link to="/integration">
            <div className="card">
                <div className="card__img">
                    <ImageFixed queryName="indexIntegracion" alt="Integración arquitectónica" />
                </div>
                <p className="card__title">{t('INDEX_CARD-3_TITLE')}</p>
                <p className="card__resume">{t('INDEX_CARD-3_RESUME')}</p>
            </div>
          </Link>
          <Link to="/recharges">
            <div className="card">
                <div className="card__img">
                    <ImageFixed queryName="indexRecargas" alt="Recargas eléctricas" />
                </div>
                <p className="card__title">{t('INDEX_CARD-4_TITLE')}</p>
                <p className="card__resume">{t('INDEX_CARD-4_RESUME')}</p>
            </div>
          </Link>
          <Link to="/cooling">
            <div className="card">
                <div className="card__img">
                    <ImageFixed queryName="indexSolarCooling" alt="Solar Cooling" />
                </div>
                <p className="card__title">{t('INDEX_CARD-5_TITLE')}</p>
                <p className="card__resume">{t('INDEX_CARD-5_RESUME')}</p>
            </div>
          </Link>
          <Link to="/hydrogen">
            <div className="card">
                <div className="card__img">
                    <ImageFixed queryName="indexHidrogeno" alt="Hidrógeno" />
                </div>
                <p className="card__title">{t('INDEX_CARD-6_TITLE')}</p>
                <p className="card__resume">{t('INDEX_CARD-6_RESUME')}</p>
            </div>
          </Link>
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage
